const recurringInput = {
  frequency: {
    title: 'Define cómo se repite este turno a lo largo del tiempo',
    values: {
      dontRepeat: 'No se repite',
      day: 'Diario',
      week: 'Semanal',
      month: 'Mensual',
    },
    labels: {
      day: 'día(s)',
      week: 'semana(s)',
      month: 'mes(es)',
    },
  },
  repeatEvery: 'Repetir cada',
  repeatOn: 'Repetir en',
  repeatOnNote: 'Seleccione al menos un día',
  ends: 'Termina',
  endsOn: 'Termina en',
  endsLabels: {
    never: 'Nunca termina',
    date: `Hasta {{date}}`,
    times: 'Después de {{number}} ocurrencias',
  },
  windowNote: 'Por ahora solo se crean los primeros {{count}} turnos. El resto se generan automáticamente mediante un proceso en segundo plano con el tiempo.',
  endsDateNote: 'La fecha de fin seleccionada es demasiado temprana: no se crearía ningún turno. Elija una fecha posterior.',

  form: {
    month: 'Mes',
    day: 'Día',
    week: 'Semana',
    year: 'Año',
    occurrences: 'Ocurrencias',
    after: 'Después',
    never: 'Nunca',
    on: 'En',
  },
};

export default recurringInput;
